import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const RequestQuoteModal = ({ isOpen, onClose, productName }) => {
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can add form submission logic
    onClose(); // Close the modal after submission
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          onClick={e => e.stopPropagation()}
          className="bg-[#f5f5f5] rounded-lg w-full max-w-4xl p-8"
        >
          {/* Form Header */}
          <div className="text-center mb-8">
            <h4 className="text-[#FF8A00] text-lg font-medium mb-2">GET IN TOUCH –</h4>
            <h2 className="text-[#2C2C90] text-3xl font-semibold">Support Is Online</h2>
          </div>

          {/* Form Fields */}
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Name"
                className="w-full px-4 py-3 rounded border border-gray-300 focus:outline-none focus:border-[#2C2C90]"
              />
              <input
                type="email"
                placeholder="Email Id"
                className="w-full px-4 py-3 rounded border border-gray-300 focus:outline-none focus:border-[#2C2C90]"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="tel"
                placeholder="Mobile Number"
                className="w-full px-4 py-3 rounded border border-gray-300 focus:outline-none focus:border-[#2C2C90]"
              />
              <input
                type="text"
                placeholder="Company Name"
                className="w-full px-4 py-3 rounded border border-gray-300 focus:outline-none focus:border-[#2C2C90]"
              />
            </div>

            <input
              type="text"
              placeholder="Address"
              className="w-full px-4 py-3 rounded border border-gray-300 focus:outline-none focus:border-[#2C2C90]"
            />

            <textarea
              placeholder="Message"
              rows="6"
              className="w-full px-4 py-3 rounded border border-gray-300 focus:outline-none focus:border-[#2C2C90] resize-none"
            ></textarea>

            <div className="flex justify-start">
              <button
                type="submit"
                className="bg-[#2C2C90] text-white px-8 py-2 rounded hover:bg-[#158880] transition-colors"
              >
                Submit
              </button>
            </div>
          </form>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default RequestQuoteModal; 